import { ReactElement } from "react";
import MainLayout from "../../components/Layouts";
import RevenueReportList from "../../components/Reports/RevenueReport";
import React from "react";
const RevenueReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <RevenueReportList />
    </MainLayout>
  );
};

export default RevenueReportPage;
